import React, { useEffect, useState } from "react";
import TableSkeleton from "../../../../../common/TableSkeleton";

const LowStocks = () => {
    const [lowStock, setLowStock] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        // easycommerce_modal(true);

        const url = `${EASYCOMMERCE.rest_base}/dashboard/lowstock`;

        fetch(url,{
            headers: {
                "Content-Type": "application/json",
                "X-WP-Nonce": EASYCOMMERCE.nonce,
            }
        })
            .then((res) => res.json())
            .then((data) => {
                // easycommerce_modal(false);
                setIsLoading(false);

                if (data.success) {
                    setLowStock(data.data.stock);
                }
            });
    }, []);

    return (
        <>
            {isLoading ? (
                <TableSkeleton numberOfRows={5} SkeletonHeight={35} />
            ) : lowStock.length === 0 ? (
                <div className=" text-sm text-ec-body px-[30px] pb-[30px]">
                    No low stock products found.
                </div>
            ): (
                <div className="px-[30px]">
                     <table class="table-auto w-full">
                        <thead>
                            <tr className="bg-ec-table-bg">
                                <th className="text-xs font-inter text-left font-medium p-3 capitalize rounded-tl-md rounded-bl-md text-ec-body rtl:text-right">
                                    Name
                                </th>
                                <th className="text-xs font-inter text-left font-medium p-3 capitalize text-ec-body rtl:text-right">
                                    Stock
                                </th>
                            </tr>
                        </thead>

                        <tbody>
                            {lowStock.map(
                                (item, index) =>
                                    index < 5 && (
                                        <>
                                            <tr
                                                className={`${
                                                    index < 4
                                                        ? "border-b border-[#F8F8F8]"
                                                        : ""
                                                } min-h-[70px]`}
                                                key={index}
                                            >
                                                <td className="px-3 font-inter py-5">
                                                    <p
                                                        href={item.link}
                                                        title={item.title.length > 35 ? item.title : null}
                                                        className="text-sm font-normal text-[#272435] hover:text-[#272435]"
                                                    >
                                                        {item.title.length > 35 ? item.title.slice(0, 35) + "..." : item.title}
                                                    </p>
                                                </td>
                                                <td className="px-3 font-inter text-left min-[1700px]:text-center py-5">
                                                    <span className="px-[6px] rounded text-sm font-medium text-[#272435]">
                                                        {item.stock}
                                                    </span>
                                                </td>
                                            </tr>
                                        </>
                                    )
                            )}
                        </tbody>
                    </table>
                </div>
               
            )}
        </>
    );
};

export default LowStocks;
